export default "/kiban/_next/static/images/padOnVia-f86f3f2d8bf2c724354c1dcadd6b5bfd.png";